/**
 * Triggers jQuery event when all CSS files are loaded. Sometimes it is necessary with asynchronous CSS
 */
jQuery(document).ready(function ($) {
    var counter = 0;

    // setTimeout(checkCss, 0);

    function checkCss() {
        let allCss = $('link[rel=stylesheet][onload]').length;

        if (window.cssCount === allCss || counter > 9) {
            $(document).trigger('afterCssLoad');
            return;
        }

        counter++;

        setTimeout(checkCss, 0);
    }


    const loader = document.querySelector(".loader-wrapper");

    if (loader) {
        loader.remove();
    }


    const meetYourAll = document.querySelector(".meet-your-all-in-one-growth-engine");

    if (meetYourAll) {
        setTimeout(function () {
            if (window.innerWidth > 576) {
                meetYourAll.style.marginTop = "-400px"
            } else {
                meetYourAll.style.marginTop = "-570px"
            }
        }, 0)
    }

    if(AOS) {
        AOS.init({
            startEvent: 'load',
            offset: 50,
            delay: 100,
            duration: 700,
            throttleDelay: 0
        });
    }

});

